import React, { useState } from "react";
import { useHistory  } from "react-router-dom";
import {
  Layout as AntLayout
} from "antd";

const { Content } = AntLayout;

const Layout = ({ children }) => {

   return (
    <AntLayout style={{ minHeight: "100vh" }}>
      {/* Main Layout */}
      <AntLayout>
        {/* Content */}
        <Content style={{ 
          minHeight: "calc(100vh - 120px)",
          overflow: "auto"
        }}>
          {children}
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
